export function setRef(ref, node) {
    if (!ref) {
        return;
    }
    if (typeof ref === 'function') {
        ref(node);
        return;
    }
    ref.current = node;
}
export function setRefs(refs, node) {
    refs.forEach(function (ref) { return setRef(ref, node); });
}
//# sourceMappingURL=refHelpers.js.map